import { RouteLocationRaw } from "vue-router";
export interface Page {
  title: string;
  description?: string;
  link?: {
    to: RouteLocationRaw;
    text: string;
  };
  videoUrl?: string;
  imageUrl?: string;
}

export interface NewFeaturePopup {
  id: string;
  pages: Page[];
}

export function dismissSelectedPopups(ids: string[]) {
  ids.forEach((id) => {
    localStorage.setItem(`dismissedFeaturePopup-${id}`, "true");
  });
  localStorage.setItem("dismissedSelectedPopups", "true");
}

export const NEW_FEATURE_POP_UP: Record<string, NewFeaturePopup> =
  Object.fromEntries(
    [
      "website-analytics-acquisition-tab",
      "website-analytics-pages-tab",
      "website-analytics-conversions-tab",
      "website-analytics-conversion-details",
      "ad-performance-overview",
      "marketing-performance-ads",
      "search-term-report",
      "search-term-detail",
      "social-media-account-summary",
      "commerce_ecom",
      "site-score",
      "page-insights-content",
      "page-insights-acquisition",
      "page-insights-site-score",
      "feed",
    ].map((route) => [
      route,
      {
        id: "timezone",
        pages: [
          {
            title: "Update your preferred timezone for accurate data 🕙🌎",
            description:
              "To make sure the data in Fyr matches what you see in platforms like Google Ads or Meta, it’s important to use the same timezone. You can now set your preferred display timezone in Fyr — making it easier to compare and trust your results. Mismatched timezones can cause differences in metrics like impressions or clicks — even if the underlying data is correct.",
            imageUrl:
              "https://lightkeeper-dev.ams3.digitaloceanspaces.com/new_feature_video/timezone.gif",
            link: {
              to: { name: "settings" },
              text: "Click here to update settings.",
            },
          },
        ],
      },
    ]),
  );
